<template>
  <div class="chat tw-w-full tw-h-screen tw-max-h-screen tw-flex tw-flex-col">
    <!-- <ChatHeader class="header tw-flex-none"></ChatHeader> -->
    <tool-bar class="bg-primary text-white" />
    <div
      class="chat-view tw-flex-auto tw-overflow-hidden tw-bg-white tw-grid tw-h-full tw-grid-cols-12 tw-grid-rows-3 tw-gap-0 tw-p-0"
    >
      <ChatConsole class="tw-col-span-3 tw-row-span-full" />
      <ChatRoom
        class="tw-row-span-full"
        :class="`${selectedRoomID ? 'tw-col-span-5' : 'tw-col-span-9'}`"
      />
      <CustomerHistory
        v-if="selectedRoomID"
        class="tw-col-span-4 tw-row-span-full"
      ></CustomerHistory>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ChatHeader from "@/ui/components/chat/ChatHeader.vue";
import ChatRoom from "./ChatRoom.vue";
import ChatConsole from "./ChatConsole.vue";
// import ChatNote from "./ChatNote.vue";
import CustomerHistory from "./CustomerHistory.vue";
import ToolBar from "@/ui/components/ToolBar.vue";

export default {
  name: "ChatView",
  components: {
    ChatHeader,
    ChatRoom,
    ChatConsole,
    // ChatNote,
    CustomerHistory,
    ToolBar,
  },
  data() {
    return {
      input: "",
      noteInput: "",
      selected: null,
      consoleSocket: null,
    };
  },
  async mounted() {
    // await this.$store.dispatch("chat/fetchRooms");
    // await this.$store.dispatch("chat/getRoomsByAgentID", {
    //   agentID: this.senderID,
    // });
    await this.$store.dispatch("chat/listAgent");
  },
  computed: {
    ...mapGetters({
      rooms: "chat/rooms",
      room: "chat/room",
      selectedRoomID: "chat/selectedRoomID",
      channel: "chat/channel",
    }),
    messages() {
      return this.channel === "main"
        ? this.mainMessages
        : this.backgroundMessages;
    },
    senderID() {
      return "001";
    },
  },
  watch: {
    selected: {
      immediate: false,
      handler: async function (val) {
        this.$store.commit("chat/setSelectedRoomID", val);
        this.fetchNote();
      },
    },
  },
  methods: {
    onClickRoom(room) {
      console.log(room);
      this.selected = room.RoomID;
    },
  },
};
</script>

<style>

body {
  color: #2c3e50;
}
.rooms::-webkit-scrollbar,
.message::-webkit-scrollbar,
.note-list::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}
.rooms::-webkit-scrollbar-thumb,
.message::-webkit-scrollbar-thumb,
.note-list::-webkit-scrollbar-thumb {
  max-height: 10%;
  border-radius: 10px;
  background: #cbd5e1;
}

</style>
